import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";
import { Observable, Subscriber } from "rxjs";
import { Messages } from "../model/messages";
import { EnvironmentHelper } from "./env.helper";

@Injectable({
  providedIn: "root",
})
export class PasswordService {
  private forgotUrl: string;
  private resetUrl: string;

  constructor(private http: HttpClient, private env: EnvironmentHelper) {
    this.forgotUrl = `${env.apiBaseUrl}invitation/request`;
    this.resetUrl = `${env.apiBaseUrl}invitation/accept`;
  }

  public sendResetLink(username: string): Observable<Messages> {
    return new Observable<Messages>((observer) => {
      this.http
        .post<any>(
          this.forgotUrl,
          { username },
          {
            headers: { "Content-Type": "application/json" },
            observe: "response",
          }
        )
        .subscribe(
          (response) => this.handleForgotResponse(response, observer),
          (error) => this.handleForgotResponse(error, observer)
        );
    });
  }

  public resetPassword(
    token: string,
    password: string,
    confirmPassword: string
  ): Observable<Messages> {
    const body = { token, password, confirmation: confirmPassword };

    return new Observable<Messages>((observer) => {
      this.http
        .put<any>(this.resetUrl, body, {
          headers: { "Content-Type": "application/json" },
          observe: "response",
        })
        .subscribe(
          (response) => this.handleResetResponse(response, observer),
          (error) => this.handleResetResponse(error, observer)
        );
    });
  }

  private handleForgotResponse(
    response: HttpResponseBase,
    observer: Subscriber<Messages>
  ) {
    if (response.status === 204) {
      observer.next(Messages.EMPTY);
    } else if (response.status === 404) {
      observer.next(
        Messages.orElse(
          (response as HttpErrorResponse).error,
          "email",
          "emai.not.found."
        )
      );
    } else if (response.status === 409) {
      observer.next(
        Messages.orElse(
          (response as HttpErrorResponse).error,
          "forgot password",
          "forgot.password.form.invalid."
        )
      );
    } else {
      observer.next(
        Messages.orElse(
          (response as HttpErrorResponse).error,
          "general",
          "an.unexpected.error.has.occurred."
        )
      );
    }
  }

  private handleResetResponse(
    response: HttpResponseBase,
    observer: Subscriber<Messages>
  ) {
    if (response.status === 204) {
      observer.next(Messages.EMPTY);
    } else if (response.status === 400) {
      observer.next(
        Messages.orElse(
          (response as HttpErrorResponse).error,
          "reset",
          "reset.password.invalid."
        )
      );
    } else if (response.status === 409) {
      observer.next(
        Messages.orElse(
          (response as HttpErrorResponse).error,
          "reset",
          "reset.password.conflict."
        )
      );
    } else if (response.status === 401) {
      observer.next(
        Messages.orElse(
          (response as HttpErrorResponse).error,
          "auth",
          "unauthorized.access."
        )
      );
    } else {
      observer.next(
        Messages.orElse(
          (response as HttpErrorResponse).error,
          "general",
          "an.unexpected.error.has.occurred."
        )
      );
    }
  }
}
